import { Component } from '@angular/core';
import { Timereg } from '@store/models';
import { TimetrackSelectors, TimetrackDispatchers } from '@store';

@Component({
    selector: 'app-time-log-lines',
    template: `<app-time-log-lines-ui
        [timeregsDate]="timeregsDate$ | async"
        [ugerapportSager]="ugerapportSager$ | async"
        [ugerapportKunder]="ugerapportKunder$ | async"
        [ugerepDoneDate]="ugerepDoneDate$ | async"
        [selectedDate]="selectedDate$ | async"
        [user]="user$ | async"
        (save)="save($event)"
        (delete)="delete($event)"
    ></app-time-log-lines-ui>`,
    standalone: false
})
export class TimeLogLinesContainerComponent {

    timeregsDate$ = this.timetrackSelector.timeregsDate$;
    ugerapportSager$ = this.timetrackSelector.ugerapportSager$;
    ugerapportKunder$ = this.timetrackSelector.ugerapportKunder$;
    ugerepDoneDate$ = this.timetrackSelector.ugerepDoneDate$;
    user$ = this.timetrackSelector.user$;
    selectedDate$ = this.timetrackSelector.date$;

    constructor(
        private timetrackSelector: TimetrackSelectors,
        private timetrackDispatch: TimetrackDispatchers
    ) { }

    save(partialTimereg: Partial<Timereg>) {
        this.timetrackDispatch.createTimereg(partialTimereg);
    }

    delete(id: number) {
        this.timetrackDispatch.deleteTimereg(id);
    }

}
